import type { FC } from 'react';
import { useMountEffect } from 'src/hooks/use-mount-effect';
import { Relax } from 'src/types/common';
import { Placeholder, PlaceholderProps } from './placeholder';

type ErrorProps = Relax<PlaceholderProps, 'message' | 'icon'> & {
  // debug message which is logged when rendering
  // (this simplifies error tracking)
  debug?: string;
};

export const Error: FC<ErrorProps> = (props) => {
  const { debug } = props;

  const {
    message = 'Es ist ein Fehler aufgetreten',
    icon = 'fa6-solid:bug',
    ...other
  } = props;

  useMountEffect(() => debug && console.error(debug));

  return (
    <Placeholder
      message={message}
      icon={icon}
      {...other}
    />
  );
};
